const course = {
  state: {
    addCourseDialog: {
      title: '新增课程信息',
      type: 'add'
    },
    courseDetails: {
      id: "",
      courseDate: "",
      courseTime: "",
      courseType: "",
      courseLocation: "",
      coursePackages: "",
      courseCoachList: []
    },
    beginCourseSearchData: {
      isHasCoachhes: 1
    },
    buttonStatus: false,
    buttonText: '点击生成excel',
    buttonStatus1: false,
    buttonText1: '点击生成会员课时情况表',
    courseSearch: {},
    courseTypeList: [],
    courseLocationList: [],
    courseSearchBtnDisabled: true
  },
  getters: {
    beginCourseSearchData: state => state.beginCourseSearchData,
    buttonStatus: state => state.buttonStatus,
    buttonText: state => state.buttonText,
    buttonStatus1: state => state.buttonStatus1,
    buttonText1: state => state.buttonText1,
    addCourseDialog: state => state.addCourseDialog,
    courseSearch: state => state.courseSearch,
    courseSearchBtnDisabled: state => state.courseSearchBtnDisabled,
    courseTypeList: state => state.courseTypeList,
    courseLocationList: state => state.courseLocationList,
    courseDetails: state => state.courseDetails
  },
  mutations: {
    SET_BEGINCOURSE_SEARCHDATA: (state, payload) => {
      state.beginCourseSearchData = payload
    },
    SET_BUTTON_STATUS: (state, payload) => {
      state.buttonStatus = payload
    },
    SET_BUTTON_TEXT: (state, payload) => {
      state.buttonText = payload
    },
    SET_BUTTON_STATUS1: (state, payload) => {
      state.buttonStatus1 = payload
    },
    SET_BUTTON_TEXT1: (state, payload) => {
      state.buttonText1 = payload
    },
    SET_COURSE_DIALOG_TITLE: (state, type) => {
      console.log("SET_COURSE_DIALOG_TITLE");
      if (type === 'add') {
        state.addCourseDialog.title = '新增课程信息'
        state.addCourseDialog.type = 'add'
      } else {
        state.addCourseDialog.title = '编辑课程信息'
        state.addCourseDialog.type = 'edit'
      }
    },
    SET_COURSE_DETAILS: (state, payload) => {
      state.courseDetails = payload
    },
    SET_COURSE_SEARCH: (state, payload) => {
      state.courseSearch = payload;
      console.log("courseSearch" + state.courseSearch);
    },
    SET_COURSE_SEARCHBTN_DISABLED: (state, payload) => {
      state.courseSearchBtnDisabled = payload;
    },
    SET_COURSE_TYPE_LIST: (state, payload) => {
      state.courseTypeList = payload;
    },
    SET_COURSE_LOCATION_LIST: (state, payload) => {
      state.courseLocationList = payload;
    }
  },
  actions: {

  }
}

export default course